(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon-single-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon-single-row.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const Badge = svs.ui.ReactBadge;
const createBetEventKey = svs.components.sportinfo.common.helpers.createBetEventKey;
const selectBetEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectBetEvent;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const CouponRowDescription = svs.components.tipsen.coupon.CouponRowDescription;
const getAriaLabelForEvent = svs.components.poolBetting.ariaUtils.getAriaLabelForEvent;
const selectParticipant = svs.components.sportinfo.matchInfoRedux.selectors.selectParticipant;

const CouponSingleRow = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    event = _ref.event,
    branding = _ref.branding,
    isSingleRowForSmallDevice = _ref.isSingleRowForSmallDevice;
  const betEvent = useSelector(state => selectBetEvent(state, createBetEventKey(productId, drawNumber, event.eventNumber)));
  const nameSize = isSingleRowForSmallDevice ? DescriptionSize.Short : DescriptionSize.Medium;
  const homeParticipant = useSelector(state => {
    var _betEvent$participant;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant = betEvent.participants) === null || _betEvent$participant === void 0 ? void 0 : _betEvent$participant[0]);
  });
  const awayParticipant = useSelector(state => {
    var _betEvent$participant2;
    return selectParticipant(state, betEvent === null || betEvent === void 0 || (_betEvent$participant2 = betEvent.participants) === null || _betEvent$participant2 === void 0 ? void 0 : _betEvent$participant2[1]);
  });
  return React.createElement("div", {
    "aria-label": getAriaLabelForEvent({
      eventTypeId: betEvent === null || betEvent === void 0 ? void 0 : betEvent.eventTypeId,
      homeParticipant,
      awayParticipant
    }),
    className: "coupon-single-row-event",
    key: event.eventNumber
  }, React.createElement(Badge, {
    branding: branding,
    className: isSingleRowForSmallDevice ? 'coupon-singels-row-number' : 'coupon-row-number'
  }, event.eventNumber), React.createElement(CouponRowDescription, {
    eventTypeId: event.eventTypeId,
    nameSize: nameSize,
    participants: betEvent === null || betEvent === void 0 ? void 0 : betEvent.participants,
    shouldUseShortNames: isSingleRowForSmallDevice
  }));
};
setGlobal('svs.components.tipsen.coupon.CouponSingleRow', CouponSingleRow);

 })(window);